module.exports = __webpack_public_path__ + "static/media/xrptoolbox-logo.c829d52e.svg";